export default function React_Router() {
  return (
    <div>
      <h1>React_Router Component</h1>
      <p>This is the React_Router tutorial page.</p>
    </div>
  );
}
